import React from 'react';
import clsx from 'clsx';

interface OwnProps {
  name: string;
  isActive: boolean;
  unreadCount?: number;
  icon: React.ReactNode;
}

const ListItem = (props: OwnProps) => {
  const { name, isActive, unreadCount = 0, icon } = props;
  return (
    <div
      className={clsx(
        'flex items-center justify-between p-2 w-full rounded-lg',
        isActive
          ? 'bg-neutral-700 text-neutral-100 font-bold hover:bg-neutral-700 hover:shadow-sm'
          : 'bg-none hover:bg-blue-100',
      )}
      key={name}
    >
      <div className="flex gap-1 items-center">
        {icon}
        <span className="overflow-hidden whitespace-nowrap text-ellipsis w-[140px]">
          {name}
        </span>
      </div>
      {unreadCount > 0 && <p className="text-red-500">{unreadCount}</p>}
    </div>
  );
};

export default ListItem;
